export default "__VITE_ASSET__D2ZMXFW3__"